import { render, staticRenderFns } from "./WorklistView.vue?vue&type=template&id=243320ae&scoped=true&"
import script from "./WorklistView.vue?vue&type=script&lang=ts&"
export * from "./WorklistView.vue?vue&type=script&lang=ts&"
import style0 from "./WorklistView.vue?vue&type=style&index=0&id=243320ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243320ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VMenu})
